<template>
  <q-modal v-model="modalOrder" no-backdrop-dismiss no-esc-dismiss>
    <div>
      <v-header
          :title="$T('order') + ' ' + (item.id || '') + ' - Logs'"
          icon="find in page">
        <template slot="right">
          <v-button flat rounded dense color="primary"
                    icon="close"
                    :label="$T('close')"
                    :disable="form.busy"
                    @click="close"/>
        </template>
      </v-header>
      <card width="100%">
        <div v-if="!loading">
          <div>
            <v-header
                :title="$T('Email Logs')"
                icon="phone">

            </v-header>
            <card width="100%">

              <form
                  class="row gutter-xs"
                  @keydown="form.onKeydown($event)">

                <div class="px-3 py-3 w-full" style="width: 100%">
                  <!--                        <loading-view :loading="loading">-->
                  <div class="card relative">
                    <div class="overflow-hidden overflow-x-auto relative">

                      <table-with-pagination :columns="emailColumns"
                                             :export-filename="`emails-export-order-${item.id}`"
                                             :export-route="`/email/${item.id}/export`"
                                             :slug="`get-emails/${item.id}`"/>


                    </div>
                  </div>
                  <!--                        </loading-view>-->
                </div>

              </form>

            </card>
          </div>
          <div>
            <v-header
                :title="$T('SMS Log')"

                icon="phone">

            </v-header>
            <card width="100%">

              <form v-if="callRows.length === 0"
                    class="row gutter-xs"
                    @keydown="form.onKeydown($event)">

                <div class="px-3 py-3 w-full" style="width: 100%">
                  <!--                        <loading-view :loading="loading">-->
                  <div class="card relative">
                    <div class="overflow-hidden overflow-x-auto relative">

                      <table-with-pagination :columns="smsColumns"
                                             :export-route="`/sms/${item.id}/export`"
                                             :slug="`get-sms/${item.id}`"
                                             :export-filename="`sms-export-order-${item.id}`"/>

                    </div>
                  </div>
                  <!--                        </loading-view>-->
                </div>

              </form>

            </card>
          </div>
          <div>
            <v-header
                :title="$T('calls')"
                icon="phone">

            </v-header>
            <card width="100%">

              <form v-if="callRows.length === 0"
                    class="row gutter-xs"
                    @keydown="form.onKeydown($event)">

                <div class="px-3 py-3 w-full" style="width: 100%">
                  <!--                        <loading-view :loading="loading">-->
                  <div class="card relative">
                    <div class="overflow-hidden overflow-x-auto relative">

                      <table-with-pagination :columns="callColumns"
                                             :export-filename="`calls-export-order-${item.id}`"
                                             :export-route="`/call/${item.id}/export`"
                                             :slug="`get-ispot-calls/${item.id}`"/>

                    </div>
                  </div>
                  <!--                        </loading-view>-->
                </div>

              </form>

            </card>
          </div>

        </div>

        <div class="justify-center row layout-padding" v-else>
          <spinner-iqos size="60px"/>
        </div>

      </card>
    </div>
  </q-modal>
</template>

<script>
import axios from "axios";
import TableWithPagination from "../../../components/TableWithPagination";

export default {
  name: "OrderCommLog",
  components: {TableWithPagination},
  props: {
    show: Boolean,
    item: {
      type: Object,
      default: {}
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
  },
  mounted () {
  },
  data () {
    return {
      form: '',
      modalOrder: this.show,
      smsRows: [],
      emailRows: [],
      callRows: [],
      loading: false,
      emailColumns: [
        {name: 'sent_at', align: 'left', label: this.$T('sent at'), field: 'sent_at', required: true},
        // {name: 'api_sent_at', align: 'left', label: this.$T('send confirmed at'), field: 'api_sent_at', required: true},
        {name: 'to', align: 'left', label: this.$T('to'), field: 'to', required: true},
        {
          name: 'success', align: 'left',
          label: this.$T('status'),
          field: obj => obj.sent ? this.$T('sent') : this.$T('not sent'),
          required: true
        },
        {name: 'text_content', align: 'left', label: this.$T('content'), field: 'text_content', required: true},
      ],
      smsColumns: [
        {name: 'created_at', align: 'left', label: this.$T('sent at'), field: 'created_at', required: true},
        {name: 'api_sent_at', align: 'left', label: this.$T('send confirmed at'), field: 'api_sent_at', required: true},
        {
          name: 'success', align: 'left',
          label: this.$T('status'),
          field: obj => obj.sent ? this.$T('sent') : this.$T('not sent'),
          required: true
        },
        {name: 'message', align: 'left', label: this.$T('content'), field: 'message', required: true},
      ],
      callColumns: [
        {name: 'duration', align: 'left', label: this.$T('call duration'), field: 'duration', required: true},
        {name: 'status', align: 'left', label: this.$T('call status'), field: 'status', required: true},
        {name: 'recording_url', align: 'left', label: this.$T('call audio'), field: 'recording_url', required: true}
      ]
    }
  },
  watch: {
    show (newVal) {
      this.modalOrder = newVal
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/backoffice/order/OrderCommLog.vue